import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch((error) => console.error("Service Worker registration failed", error)));
}

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
